// [2026-11-04] CSS ของหน้า login / สมัคร / หน้าสมาชิก (loginregis.css + css/app.css)
//   เดิมแต่ละหน้าแปะ <link> ตอน componentDidMount -> หน้าโผล่ก่อน CSS โหลด = กระพริบ/เพี้ยนแวบหนึ่ง
//   + ใช้ path แบบ './loginregis.css' (ถ้า URL มีหลายชั้น เช่น /refer/overview จะหาไฟล์ไม่เจอ)
//   ตอนนี้: แปะครั้งเดียว (path จาก root) แล้วรอโหลดเสร็จก่อนค่อยแสดงหน้า (กันค้าง 3 วิ)
const FILES = [
  { id: 'auth-css-loginregis', href: (process.env.PUBLIC_URL || '') + '/loginregis.css' },
  { id: 'auth-css-app', href: (process.env.PUBLIC_URL || '') + '/css/app.css' },
];
let ready = false;
let waiters = [];
function done() {
  if (ready) return;
  ready = true;
  const w = waiters; waiters = [];
  w.forEach((fn) => { try { fn(); } catch (e) { } });
}
export function authCssReady() { return ready; }
export function loadAuthCss(cb) {
  if (ready) { if (cb) cb(); return; }
  if (cb) waiters.push(cb);
  let left = 0;
  FILES.forEach((f) => {
    let el = document.getElementById(f.id);
    if (el && el.dataset.loaded === '1') return;
    left++;
    const finish = () => { if (el) el.dataset.loaded = '1'; left--; if (left <= 0) done(); };
    if (!el) {
      el = document.createElement('link');
      el.id = f.id; el.rel = 'stylesheet'; el.href = f.href;
      el.onload = finish; el.onerror = finish;
      document.head.appendChild(el);
    } else {
      el.addEventListener('load', finish); el.addEventListener('error', finish);
    }
  });
  if (left <= 0) done();
  setTimeout(done, 3000);
}
